<script>
  export let question;
  export let updateWorkingQuestion;
  
</script>

<div class="edit-section">
  <h4>Basic Information</h4>
  
  <div class="form-styled">
    <div class="field-wrapper">
      <label>ID</label>
      <input 
        type="text"
        value={question.id}
        disabled
        class="disabled-field"
      />
    </div>
    
    <div class="field-wrapper">
      <label>Type</label>
      <select 
        value={question.kind}
        on:change={(e) => updateWorkingQuestion('kind', e.target.value)}
      >
        <option value="Text">Text</option>
        <option value="CheckBox">CheckBox</option>
        <option value="Select">Select</option>
        <option value="Quant">Quant</option>
        <option value="Map">Map</option>
        <option value="DateTime">DateTime</option>
      </select>
    </div>
    
    <div class="field-wrapper">
      <label>Label</label>
      <textarea 
        value={question.label || ''}
        on:input={(e) => updateWorkingQuestion('label', e.target.value)}
        rows="3"
        placeholder="Question label or prompt"
      ></textarea>
    </div>

    <div class="field-wrapper">
      <label>Tour Text</label>
      <textarea 
        value={question.tourText || ''}
        on:input={(e) => updateWorkingQuestion('tourText', e.target.value)}
        rows="3"
        placeholder="Question tour text"
      ></textarea>
    </div>
    
    <div class="field-wrapper">
      <label class="checkbox-item">
        <input 
          type="checkbox"
          checked={question.allowEmpty === false}
          on:change={(e) => updateWorkingQuestion('allowEmpty', !e.target.checked)}
        />
        Required (allowEmpty: false)
      </label>
    </div>

    <!--this is not added needs work-->
    <div class="field-wrapper">
      <label class="checkbox-item">
        <input 
          type="checkbox"
          checked={question.skipQuestion === true}
          on:change={(e) => updateWorkingQuestion('skipQuestion', e.target.checked)}
        />
        Skip Question
      </label>
    </div>
    
    {#if question['nested'] !== undefined}
      <div class="field-wrapper">
        <label>Nested Group</label>
        <input 
          type="text"
          value={question.nested || ''}
          on:input={(e) => updateWorkingQuestion('nested', e.target.value)}
          placeholder="e.g., nest0"
        />
        <button 
          class="btn btn-small btn-warning"
          on:click={() => updateWorkingQuestion('nested', undefined)}
        >
          Remove Nested
        </button>
      </div>
    {:else}
      <button 
        class="btn btn-secondary"
        on:click={() => updateWorkingQuestion('nested', 'nest0')}
      >
        Add Nested Group
      </button>
    {/if}
  </div>
</div>

<style lang="scss">
  .edit-section {
    border: 4px solid #d4d3bc;
    border-radius: 0;
    padding: 15px;
    margin-bottom: 20px;
    background: #f3f2e3;
    
    h4 {
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 0.9rem;
    }
  }
  
  .field-wrapper {
    margin-bottom: 15px;
    
    label {
      display: inline-flex;
      font-weight: bold;
      margin-bottom: 5px;
      font-size: 0.75rem;
      color: #464b4b;
    }
    
    input, select, textarea {
      width: 100%;
      padding: 8px 12px;
      border: 4px solid #d4d3bc;
      border-radius: 0;
      background: #f3f2e3;
      font-size: 0.75rem;
      
      &:focus {
        outline: none;
        border-color: #10b981;
        background: #fff;
      }
    }
  }
  
  .disabled-field {
    background: #e3e2d3 !important;
    color: #6b7280;
    cursor: not-allowed;
  }
  
  .checkbox-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 0.75rem;
    
    input {
      margin-right: 8px;
      width: auto;
    }
  }
  
  .btn {
    padding: 6px 12px;
    border: none;
    border-radius: 0;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.2s ease;
    
    &.btn-secondary {
      background: #10b981;
      color: white;
      
      &:hover {
        background: #059669;
      }
    }
    
    &.btn-small {
      padding: 4px 8px;
      font-size: 12px;
    }
    
    &.btn-warning {
      background: #f59e0b;
      color: white;
      
      &:hover {
        background: #d97706;
      }
    }
  }
</style>